import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components
import ModalPopup from '../shared/modal/ModalPopup'

type ErrorModal = {
  title?: string
  message: string
  visible: boolean
  setVisible: any
}

const ErrorModal = ({
  title = 'Alert',
  message,
  visible,
  setVisible
}: ErrorModal) => {
  return (
    <ModalPopup visible={visible}>
      <View style={styles.modalHeader}>
        <View
          style={[
            globalStyles.hDirection,
            globalStyles.vStartItems,
            globalStyles.vCenterItems
          ]}
        >
          <Ionicons name="alert-circle" size={24} color={colorPalette.red} />
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs18,
              globalStyles.fwBold,
              globalStyles.dangerTextColor,
              globalStyles.ml1
            ]}
          >
            {title}
          </Text>
        </View>

        <TouchableOpacity onPress={() => setVisible(!visible)}>
          <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
        </TouchableOpacity>
      </View>
      <View style={[styles.modalBody]}>
        <View style={[styles.modalBodyInner]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs16,
              globalStyles.fwLight,
              globalStyles.blackTextColor
            ]}
          >
            {message}
          </Text>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    paddingVertical: 0,
    paddingHorizontal: 0
  },
  modalBodyInner: {
    paddingHorizontal: 16,
    paddingVertical: 25,
    paddingBottom: 30
  },
  dayCol: {
    minWidth: 90
  }
})

export default ErrorModal
